<template>
    <div class="wrap user">
        <div class="banner user-banner">
            <div class="container">
                <div class="row">
                    <img :src="user.avatar" :alt="user.nickname" class="avatar">
                    <div class="username">{{user.nickname}}</div>
                    <div class="signature">
                        {{user.signature}}
                    </div>
                </div>
            </div>
            <div class="nav">
                <router-link :to="{'path':'/user/report'}" tag="a" class="item" active-class="active">我的报告</router-link>
                <!--<router-link :to="{'path':'/user/tags'}" tag="a" class="item" active-class="active">我的标签</router-link>-->
                <!-- <router-link :to="{'path':'/user/indicators'}" tag="a" class="item" active-class="active">我的指标</router-link>  -->
                <router-link :to="{'path':'/user/evaluates'}" tag="a" class="item" active-class="active">我的测评</router-link>
                <router-link :to="{'path':'/user/join-company'}" tag="a" class="item" active-class="active" v-if="user.category === 1 && user.role === 1">关联企业</router-link>
                <router-link :to="{'path':'/user/setting'}" tag="a" class="item" active-class="active">个人设置</router-link>
            </div>
        </div>
        <div class="p-t-md">
            <div class="container clearfix">
                <div class="row" style="min-height:520px;">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({ user: "loginUser" })
  }
};
</script>
<style lang="less">

</style>




// WEBPACK FOOTER //
// user.vue?d63eeeca